import { Box, Grid, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../../widgets';
import SelectFieldMateriasComponent from '../../../../control_estudios/materias/components/SelectFieldMaterias';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldBloquesPedagogicosComponent from '../../../bloques_pedagogicos/components/SelectFieldBloquesPedagogicos';
import { oneDocentesAction } from '../../../docentes/DocentesAction';
import SelectFieldDocentesComponent from '../../../docentes/components/SelectFieldDocentes';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import { savePlanEvaluacionAction } from '../PlanEvaluacionAction';

const FormPlanEvaluacion = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const materiasStore = Redux.useSelector((state) => state.materias);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const activo = planEvaluacionStore.activo;

  const initData = {
    temaIndispensable: '',
    temaGenerador: '',
    desc: '',
    idDocente: loginStore.isTeacher ? docentesStore.activo.id : '',
    idMateria: '',
    idSeccion: '',
    idFechaBloque: '',
    idEstatus: loginStore.isAdminTeacher ? 1 : 2,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idDocente: false,
    idSeccion: false,
    idMateria: false,
    idFechaBloque: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [loadingGetOne, setLoadingGetOne] = React.useState(false);

  const [secciones, setSecciones] = React.useState([]);
  const [materias, setMaterias] = React.useState([]);

  const [idBloquePedagogico, setIdBloquePedagogico] = React.useState(
    activo?.fechaBloque?.bloquePedagogico.id ?? '',
  );

  React.useEffect(() => {
    const fetchData = () => {
      if (!activo) return;
      let values = {};
      Object.keys(data).map((key) => (values[key] = activo[key]));
      setTimeout(
        () =>
          setData({
            ...values,
            idDocente: activo.docente.id,
            idMateria: activo.materia.id,
            idSeccion: activo.seccion.id,
            idFechaBloque: activo.fechaBloque.id,
            idEstatus: activo.estatus.id,
          }),
        300,
      );
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await savePlanEvaluacionAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        planEvaluacionStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const getDocenteData = async (id) => {
    if (!id) return;
    setData({ ...data, idDocente: id });
    setLoadingGetOne(true);
    await oneDocentesAction(dispatch, id);
    setLoadingGetOne(false);
  };

  React.useEffect(() => {
    if (docentesStore.activo && !loginStore.isAdminTeacher) {
      docentesStore.activo?.materias.forEach((el) =>
        setMaterias((prev) => [...prev, el.materia]),
      );

      docentesStore.activo?.secciones.forEach((el) =>
        setSecciones((prev) => [...prev, el.seccion]),
      );
    } else {
      setMaterias(materiasStore.all);
      setSecciones(seccionesStore.all);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docentesStore.activo]);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <LoadingWidget
          isLoading={loadingSave || loadingGetOne}
          isActivo={activo}
        />
        {!loginStore.isTeacher && (
          <Grid item xs={12} md={loginStore.isTeacher ? 12 : 6}>
            <SelectFieldDocentesComponent
              isEmpty={false}
              isAll={false}
              required
              open={!planEvaluacionStore.params.idDocente && !activo}
              value={data.idDocente}
              onChange={(idDocente) => getDocenteData(idDocente)}
              error={dataError.idDocente}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <SelectFieldMateriasComponent
            value={data.idMateria}
            data={loginStore.isAdminTeacher ? null : materias}
            isEmpty={false}
            isAll={false}
            required
            onChange={(idMateria) =>
              _handleSetDataField(CONST.materia.idName, idMateria)
            }
            error={dataError.idMateria}
          />
        </Grid>
        <Grid item md={6}>
          <SelectFieldBloquesPedagogicosComponent
            isEmpty={false}
            isAll={false}
            value={idBloquePedagogico}
            required
            onChange={(idBloque) => {
              const res = bloquesPedagogicosStore.all.find(
                (e) => e.id === idBloque,
              );
              if (!res.fechaActiva) {
                return notify('Falta la fecha de inicio del bloque', {
                  warning: true,
                });
              }
              setIdBloquePedagogico(idBloque);
              _handleSetDataField(CONST.fechaBloque.idName, res.fechaActiva.id);
            }}
            error={dataError.idFechaBloque}
          />
        </Grid>

        <Grid item md={loginStore.isAdminTeacher ? 12 : 6}>
          <SelectFieldSeccionesComponent
            value={data.idSeccion}
            isEmpty={false}
            isAll={false}
            required
            data={loginStore.isAdminTeacher ? null : secciones}
            onChange={(idSeccion) => {
              _handleSetDataField(CONST.seccion.idName, idSeccion);
            }}
            error={dataError.idSeccion}
          />
        </Grid>
        {loginStore.isAdminTeache && (
          <Grid item xs={12} md={6}>
            <EstatusField
              value={data.idEstatus}
              onChange={(e) =>
                _handleSetDataField(CONST.estatus.idName, e.target.value)
              }
              isEstatus
              required
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.temaIndispensable.name}
            label={CONST.temaIndispensable.label}
            value={data.temaIndispensable}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.temaIndispensable.name, e.target.value)
            }
            helperText={
              dataError.temaIndispensable ? validMessage.required : null
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.temaGenerador.name}
            label={CONST.temaGenerador.label}
            value={data.temaGenerador}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.temaGenerador.name, e.target.value)
            }
            helperText={dataError.temaGenerador ? validMessage.required : null}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormPlanEvaluacion;
